// import {
//   format,
//   isValid,
//   parseISO,
//   isToday,
//   isTomorrow,
//   isThisWeek,
//   endOfWeek,
//   differenceInSeconds,
//   endOfDay,
//   startOfDay,
//   isPast,
// } from 'date-fns'

// export const DateFormat = {
//   localISO: "yyyy-MM-dd'T'HH:mm:ssXXX",
//   date: 'yyy-MM-dd',
//   dateTime: 'yyy-MM-dd hh:mm',
//   MMDDYYYY: 'MM-dd-yyyy',
//   DDMMYYYY: 'dd-MM-yyyy',
//   mmDD: 'MMMM d',
// }

// export class DateUtility {
//   static dateToLocalISO = (date, formatDate = DateFormat.localISO) => {
//     if (!isValid(date)) {
//       return null
//     }
//     const isoDate = parseISO(date.toISOString())
//     return format(isoDate, formatDate)
//   }

//   static isToday(date) {
//     return isToday(date)
//   }

//   static isTomorrow(date) {
//     return isTomorrow(date)
//   }

//   static isThisWeek(date) {
//     return isThisWeek(date)
//   }

//   static endOfWeek(date) {
//     return endOfWeek(date)
//   }

//   static endDay(date) {
//     return endOfDay(date)
//   }

//   static isPast(date) {
//     return isPast(date)
//   }

//   static startDay(date) {
//     return startOfDay(date)
//   }

//   static differenceInSeconds(date1, date2) {
//     return differenceInSeconds(date1, date2)
//   }

//   static getDaysRemaining(date) {
//     const diffInMs = new Date(date) - new Date()
//     const diffInDays = Math.ceil(diffInMs / (1000 * 60 * 60 * 24))
//     return diffInDays > 0 ? `${diffInDays} days` : 'Ended'
//   }
// }
import {
  format,
  isValid,
  parseISO,
  isToday,
  isTomorrow,
  isThisWeek,
  endOfWeek,
  differenceInSeconds,
  endOfDay,
  startOfDay,
  isPast,
  formatDistanceToNow,
} from 'date-fns'

export const DateFormat = {
  localISO: "yyyy-MM-dd'T'HH:mm:ssXXX",
  date: 'yyy-MM-dd',
  dateTime: 'yyy-MM-dd hh:mm',
  DD_MM_YYYY_Time: 'dd-mm-yyyy hh:mm:ss',
  MMDDYYYY: 'MM-dd-yyyy',
  DDMMYYYY: 'dd-MM-yyyy',
  DDMMYYYY_: 'dd/MM/yyyy',
  mmDD: 'MMMM d',
  fullDate: 'd MMMM, yyyy', // ✅ New format added
}

export class DateUtility {
  static dateToLocalISO = (date, formatDate = DateFormat.localISO) => {
    if (!isValid(date)) {
      return null
    }
    const isoDate = parseISO(date.toISOString())
    return format(isoDate, formatDate)
  }

  static formatDate = (date, formatDate = DateFormat.fullDate) => {
    console.log("🚀 ~ DateUtility ~ formatDate ~ date:", date);

    // Check if date is valid
    if (!date || !isValid(new Date(date))) {
      console.error("Invalid date provided.");
      return null; // If the date is invalid, return null
    }

    try {
      // Format the date
      const formattedDate = format(new Date(date), formatDate);
      console.log("🚀 ~ DateUtility ~ formatDate ~ formattedDate:", formattedDate);
      return formattedDate;
    } catch (error) {
      console.error("Error formatting date:", error);
      return null;
    }
  };

  static isToday(date) {
    return isToday(date)
  }

  static isTomorrow(date) {
    return isTomorrow(date)
  }

  static isThisWeek(date) {
    return isThisWeek(date)
  }

  static endOfWeek(date) {
    return endOfWeek(date)
  }

  static endDay(date) {
    return endOfDay(date)
  }

  static isPast(date) {
    return isPast(date)
  }

  static startDay(date) {
    return startOfDay(date)
  }

  static differenceInSeconds(date1, date2) {
    return differenceInSeconds(date1, date2)
  }

  static getDaysRemaining(date) {
    const diffInMs = new Date(date) - new Date()
    const diffInDays = Math.ceil(diffInMs / (1000 * 60 * 60 * 24))
    return diffInDays > 0 ? `${diffInDays} days` : 'Ended'
  }

  static startsIn(date) {
    const diffInMs = new Date(date) - new Date();
    const diffInDays = Math.ceil(diffInMs / (1000 * 60 * 60 * 24));
    return diffInDays > 0 ? `Starts in ${diffInDays} days` : 'Already started';
  }

  static startsInOnly(date) {
    const now = new Date();
    const target = new Date(date);
    const diffInMs = target.getTime() - now.getTime();

    if (diffInMs <= 0) return 'Already started';

    const seconds = Math.floor(diffInMs / 1000);
    const minutes = Math.floor(seconds / 60);
    const hours = Math.floor(minutes / 60);
    const days = Math.floor(hours / 24);

    if (days > 0) return `${days} day${days > 1 ? 's' : ''}`;
    if (hours > 0) return `${hours} hour${hours > 1 ? 's' : ''}`;
    if (minutes > 0) return `${minutes} minute${minutes > 1 ? 's' : ''}`;
    return `${seconds} second${seconds > 1 ? 's' : ''}`;
  }

  static humanize = inputDate => {
    if (inputDate) {
      return formatDistanceToNow(inputDate, { addSuffix: false })
    }
    return ''
  }

  static toDateString = (value) => {
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return null;
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Month is 0-based
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };
}
